import { LiquidityStreamRequest } from 'widgets/liquiditySummary/api/LiquiditySummaryStreamRequest';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';
import { buildSymbolDependentRequestHelpers } from 'widgets/streaming/buildSymbolDependentRequestHelpers';
import { WidgetConfigWithSymbol } from 'widgets/WidgetSettingsEditing/WidgetSettingsSymbolEditor';

function toRequestUid(
    symbol: string,
    _configState: WidgetConfigWithSymbol,
    qty?: number
): string {
    return `liquidity-${symbol}|${qty ?? 1}`;
}

function requestToStreamKey(request: LiquidityStreamRequest): string {
    const { symbol, qty } = request;
    return toRequestUid(symbol, {}, qty);
}

function buildRequest(
    symbol: string,
    symbology: SymbologyValues,
    _configState: WidgetConfigWithSymbol,
    qty?: number
): LiquidityStreamRequest {
    return {
        symbol,
        symbology,
        qty: qty ?? 1,
    };
}

const {
    createWidgetRequestUid,
    getWidgetStreamRequestInfo,
    getStreamRequestInfosForSymbols,
} = buildSymbolDependentRequestHelpers<
    LiquidityStreamRequest,
    WidgetConfigWithSymbol
>(toRequestUid, requestToStreamKey, buildRequest, {});

export {
    createWidgetRequestUid as createLiquidityRequestUid,
    getWidgetStreamRequestInfo as getLiquidityStreamRequestInfo,
    getStreamRequestInfosForSymbols as getLiquidityStreamRequestInfosForSymbols,
    toRequestUid as toLiquidityRequestUid,
};
